"use client";

// src/components/Text/Text.tsx
import { jsx } from "react/jsx-runtime";
var Text = ({
  type,
  size = "medium",
  variant = "primary",
  children,
  className = "",
  ...rest
}) => {
  const textTypes = {
    "DISPLAY-MEDIUM": "text-5xl font-bold",
    "HEADING-LARGE": "text-4xl font-bold",
    LARGE: "text-3xl font-semibold",
    MEDIUM: "text-2xl font-medium",
    SMALL: "text-base font-normal",
    "HEADING-SMALL": "text-xl font-semibold"
  };
  const textVariants = {
    primary: "text-gray-900",
    // Cor primária
    secondary: "text-gray-600"
    // Cor secundária
  };
  const textClass = [
    "leading-tight",
    textTypes[type],
    // Aplica o tipo de texto
    textVariants[variant],
    // Aplica a variante
    `text-${size}`,
    // Tamanho do texto
    className
    // Classe personalizada
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ jsx("div", { className: textClass, ...rest, children });
};
var Text_default = Text;

export {
  Text_default
};
